import React, { useEffect, useState } from "react";
import { Button, Col, Form, message, Modal, Row, Skeleton } from "antd";
import { trans, SaveButton, SelectWithSearch, UploadFile, InputText, InputDate, CardHeader } from "@comps/components";
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { createSelectList, checkPermissions } from '@comps/commonFunctions';
import { getEmployeeRelatedDataReq, matchCnicReq, getEmployeeByIdReq, getEmploymentHistoryReq, updateEmployeeReq } from "../requests";
import { Const } from '../../constants';
import { CloseOutlined } from '@ant-design/icons';
import "./Employee.css"
import dayjs from 'dayjs';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { employeeTooltips } from "../../common/employeeTooltips";

const langKey = Const["employee"].lngKey

const fieldLabel = makeFieldLabel(employeeTooltips.profile, { namespace: "profile", label: (key) => trans(`${langKey}.${key}`) });
const formName = "updateEmployee";
const UpdateEmployeeInfo = (props) => {
  const [personalInformationEditMode, setPersonalInformationEditMode] = useState(false);
  const [CNICEditMode, setCNICEditMode] = useState(false);
  const [drivingEditMode, setDrivingEditMode] = useState(false);
  const [passportEditMode, setPassportEditMode] = useState(false);

  const handleEditClickDriving = () => {
    setDrivingEditMode(!drivingEditMode);
  };

  const handleEditClickPersonalInformation = () => {
    setPersonalInformationEditMode(!personalInformationEditMode);
  }
  const handleEditClickCNIC = () => {
    setCNICEditMode(!CNICEditMode)
  }

  const handleEditClickPassport = () => {
    setPassportEditMode(!passportEditMode)
  }

  const handleSaveClick = () => {
    // Handle the save action here, e.g., submit the form data
    // You can access the edited data in formData
    // Implement your save logic here

    // After saving, you may want to exit edit mode
    setPersonalInformationEditMode(false);
  };


  const [form] = Form.useForm()
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [employmentHistoryLoader, setEmploymentHistoryLoader] = useState(false);
  const [employmentHistoryVisible, setEmploymentHistoryVisible] = useState(false);
  const [employmentHistory, setEmploymentHistory] = useState([]);
  const [selectedNationality, setSelectedNationality] = useState(166)


  const [errors, setErrors] = useState([]);
  const [salutations, setSalutations] = useState([]);
  const [martialstatuses, setMartialstatuses] = useState([]);
  const [religions, setReligions] = useState([]);
  const [genders, setGenders] = useState([]);
  const [bloodgroups, setBloodgroups] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  //const [defaultProfile, setDefaultProfile] = useState();
  useEffect(() => {
    getEmployeeById(props.id);
    getRemoteData();
    //getCompanyRelatedData();
  }, [props]);

  //select
  const getEmployeeById = (id) => {
    makeRequest(setLoader, getEmployeeByIdReq, id, onGetEmployeeSuccess, null);
  }
  const getRemoteData = () => {
    makeRequestStateless(getEmployeeRelatedDataReq, false, onEmployeeRelatedDataSuccess, onEmployeeRelatedDataError)
  }
  const onGetEmployeeSuccess = (response) => {
    setLoading(false)
    setprofilePicFileList(response.employee.profile_pic_attachment ? [response.employee.profile_pic_attachment] : [])
    setcnicFileList(response.employee.cnic_attachment ? [response.employee.cnic_attachment] : [])
    setpassportFileList(response.employee.passport_attachment ? [response.employee.passport_attachment] : [])
    setdrivingLicenseFileList(response.employee.driving_license_attachment ? [response.employee.driving_license_attachment] : [])
    response.employee.d_o_b = dayjs(response.employee.d_o_b)
    response.employee.cnic_expiry_date = response.employee.cnic_expiry_date ? dayjs(response.employee.cnic_expiry_date) : null
    response.employee.passport_expiry_date = response.employee.passport_expiry_date ? dayjs(response.employee.passport_expiry_date) : null
    response.employee.driving_license_expiry_date = response.employee.driving_license_expiry_date ? dayjs(response.employee.driving_license_expiry_date) : null

    form.setFieldsValue(response.employee)
  }
  const onEmployeeRelatedDataSuccess = (data, res) => {
    setLoading(false)
    setSalutations(createSelectList(data.salutations))
    setNationalities(createSelectList(data.countries))
    setBloodgroups(createSelectList(data.bloodgroups))
    setGenders(createSelectList(data.genders))
    setReligions(createSelectList(data.religions))
    setBloodgroups(createSelectList(data.bloodgroups))
    setMartialstatuses(createSelectList(data.maritalstatuses
    ))
  }

  const onEmployeeRelatedDataError = (err) => {
    console.error(err)
  }

  const openEmploymentHistory = () => {
    makeRequest(setEmploymentHistoryLoader, getEmploymentHistoryReq, props.id, onEmploymentHistorySuccess, onEmploymentHistoryError);
  }

  const onEmploymentHistorySuccess = (response) => {
    setEmploymentHistory(response.employment_history || []);
    setEmploymentHistoryVisible(true);
  }

  const onEmploymentHistoryError = (error, response) => {
    message.error(response?.response?.data?.message || 'Unable to fetch employment history.');
  }

  //------------on submit forms----------------
  const onSubmitFirstStep = (data) => {
    setFirstStepData(data)
    data.cnic_attachment = cnicFileList.length > 0 && cnicFileList[0].id === undefined ? cnicFileList[0].originFileObj : null
    data.driving_license_attachment = drivingLicenseFileList.length > 0 && drivingLicenseFileList[0].id === undefined ? drivingLicenseFileList[0].originFileObj : null
    data.passport_attachment = passportFileList.length > 0 && passportFileList[0].id === undefined ? passportFileList[0].originFileObj : null
    setLoader(true)
    data.d_o_b = data.d_o_b.format('YYYY-MM-DD');
    let payload = { employee_info: data }

    payload.employee_info.id = props.id;
    makeRequest(setLoader, updateEmployeeReq, payload, onEmployeeUpdateSuccess, onEmployeeUpdateError);
  }

  const onEmployeeUpdateSuccess = (response) => {
    setLoader(false)
    message.success('Employee Updated Successfully!')
    props.setDefaultProfileCard(
      {
        'full_name': response.employee_info.full_name,
        'department_name': response.employee_info.department_name,
        'age': response.employee_info.age,
        'profile_pic_url': response.employee_info.profile_pic_url,
        'profile_score': response.employee_info.profile_score,
        'mobile_no': response.employee_info.mobile_no,
        // 'designation_name': response.employee_info.employment_info[0].designation_name,
        // 'official_email': response.employee_info.employment_info[0].official_email,
        // 'code': response.employee_info.employment_info[0].emp_code
      }
    )
  }
  const onEmployeeUpdateError = (error, response) => {
    message.error(response.response.data.message)
  }

  //-----------------onChange--------------------
  const onChangeNationality = (data) => {
    setSelectedNationality(data)
  }

  const onChangeCnic = (e) => {
    let count = e.target.value.toString().length;
    if (count > 12) {
      makeRequestStateless(matchCnicReq, e.target.value, onMatchCnicSuccess, onMatchCnicError);
    }
  }
  const onMatchCnicSuccess = (response) => {
    if (response.result) {
      message.error('Warning! Cnic matched with another employee in the system.!')
    }
  }
  const onMatchCnicError = (response) => {

  }

  //-------------------end--------------------
  // ------------------------------------
  //---------------------form layout------------
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 16,
      },
    },
  }
  //============uploading file============
  //const [fileList, setFileList] = useState([]);
  const [profilePicFileList, setprofilePicFileList] = useState([]);
  const [cnicFileList, setcnicFileList] = useState([]);
  const [passportFileList, setpassportFileList] = useState([]);
  const [drivingLicenseFileList, setdrivingLicenseFileList] = useState([]);

  //=========================================
  //------------------------------------
  //------------current step---------
  const [firstStepData, setFirstStepData] = useState();

  const formatHistoryDate = (date) => {
    return date ? dayjs(date).format('DD MMM YYYY') : '-';
  }

  const historyField = (label, value, className = '') => (
    <div className={ `employment-history-field ${className}` }>
      <span className="employment-history-field__label">{ label }</span>
      <span className="employment-history-field__value">{ value || '-' }</span>
    </div>
  );

  const getHistoryTitle = (history) => {
    const label = history.tenure_label || '';
    return label.replace(/\s*\d+:?$/, '') || 'Employment Tenure';
  }

  const getHistoryCount = (history, index) => {
    return history.tenure_identifier && history.tenure_identifier !== '-'
      ? history.tenure_identifier
      : `#${index + 1}`;
  }

  const firstStep = () => {

    return (
      <>
        <div style={ { border: '1px solid #C9D6DF', marginTop: 20, borderRadius: 10 } }>
          <CardHeader
            title="Personal Information"
            canEdit={ !personalInformationEditMode && checkPermissions('profile_employeeEmployment') }
            onEdit={ handleEditClickPersonalInformation }
          />
          <Skeleton loading={ loading }  >
            <Form
              { ...formLayout }
              form={ form }
              name={ formName }
              onFinish={ onSubmitFirstStep }
              className="custom-form"
              disabled={ !personalInformationEditMode }
              scrollToFirstError
            >
              <div style={ { marginLeft: 12, marginTop: 20, overflowY: 'auto' } }>
                <Row gutter={ [30, 0] }>
                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="salutation_id" label={ fieldLabel("salutation_id", trans(`${langKey}.selectSalutation`)) } rules={ rules.salutation_id } className="da-mb-16"
                      { ...getErrorProps(errors['salutation_id']) }
                    >
                      <SelectWithSearch
                        placeholder={ trans(`${langKey}.selectSalutation`) }
                        options={ salutations }
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="first_name" rules={ rules.first_name } label={ fieldLabel("first_name", trans(`${langKey}.firstName`)) } className="da-mb-16"
                      { ...getErrorProps(errors['first_name']) } size="small"
                    >
                      <InputText placeholder={ 'First Name' } />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="middle_name" rules={ rules.middle_name } label={ fieldLabel("middle_name", trans(`${langKey}.middleName`)) } className="da-mb-16"
                      { ...getErrorProps(errors['middle_name']) } size="small"
                    >
                      <InputText placeholder="Middle Name" />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="last_name" rules={ rules.last_name } label={ fieldLabel("last_name", trans(`${langKey}.lastName`)) } className="da-mb-16"
                      { ...getErrorProps(errors['last_name']) } size="small"
                    >
                      <InputText placeholder="Last Name" />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="father_or_husband_name" rules={ rules.father_or_husband_name } label={ fieldLabel("father_or_husband_name", "Father/Husband Name") } className="da-mb-16"
                      { ...getErrorProps(errors['name']) } size="small"
                    >
                      <InputText placeholder='Enter here' />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="gender_id" label={ fieldLabel("gender_id", trans(`${langKey}.selectGender`)) } rules={ rules.gender_id } className="da-mb-16"
                      { ...getErrorProps(errors['gender_id']) }
                    >
                      <SelectWithSearch
                        placeholder={ trans(`${langKey}.selectGender`) }
                        options={ genders }
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="d_o_b" rules={ rules.d_o_b } label={ fieldLabel("d_o_b", trans(`${langKey}.dob`)) } className="da-mb-16"
                      { ...getErrorProps(errors['d_o_b']) } size="small"
                    >
                      <InputDate
                        format="DD-MMM-YYYY" />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item
                      name="marital_status_id" label={ fieldLabel("marital_status_id", trans(`${langKey}.selectMartialStatus`)) } rules={ rules.marital_status_id } className="da-mb-16"
                      { ...getErrorProps(errors['marital_status_id']) }
                    >
                      <SelectWithSearch
                        placeholder={ trans(`${langKey}.selectMartialStatus`) }
                        options={ martialstatuses }
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item style={ { paddingTop: 8 } } name="religion_id" label={ fieldLabel("religion_id", trans(`${langKey}.selectReligion`)) } rules={ rules.religion_id } className="da-mb-16"
                      { ...getErrorProps(errors['religion']) }
                    >
                      <SelectWithSearch
                        placeholder={ trans(`${langKey}.selectReligion`) }
                        options={ religions }
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item style={ { paddingTop: 10 } }
                      name="nationality_id" label={ fieldLabel("nationality_id", trans(`${langKey}.selectNationality`)) } rules={ rules.nationality_id } className="da-mb-16"
                      { ...getErrorProps(errors['nationality_id']) }
                    >
                      <SelectWithSearch
                        onChange={ onChangeNationality }
                        placeholder={ trans(`${langKey}.selectNationality`) }
                        options={ nationalities }
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item style={ { paddingTop: 8 } } name="blood_group_id" label={ fieldLabel("blood_group_id", trans(`${langKey}.selectBloodGroup`)) } rules={ rules.blood_group } className="da-mb-16"
                      { ...getErrorProps(errors['blood_group_id']) }
                    >
                      <SelectWithSearch
                        placeholder={ trans(`${langKey}.selectBloodGroup`) }
                        options={ bloodgroups }
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item style={ { paddingTop: 5 } } name="mobile_no" label={ fieldLabel("mobile_no", trans(`${langKey}.mobile`)) } className="da-mb-16"
                      { ...getErrorProps(errors['mobile_no']) } size="small"
                    >
                      <InputText placeholder="XXXXXXXXXX" />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="landline_no" rules={ rules.landline_no } label={ fieldLabel("landline_no", trans(`${langKey}.landline`)) } className="da-mb-16"
                      { ...getErrorProps(errors['landline_no']) } size="small"
                    >
                      <InputText placeholder="XXXXXXXXXX" />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="email" label={ fieldLabel("email", trans(`${langKey}.email`)) } className="da-mb-16"
                      { ...getErrorProps(errors['email']) } size="small"
                    >
                      <InputText placeholder="abc@xyz.com" />
                    </Form.Item>
                  </Col>
                  {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item label={ fieldLabel("profile_pic", "Upload photo") } name="profile_pic" >
                      <UploadFile accept=".jpg,.png,.jpeg"
                        listType="picture-card"
                        fileList={ profilePicFileList }
                        onChange={ onChangeProfilePic }
                        onPreview={ onPreview }
                        multiple={ false }
                        beforeUpload={ (file) => {
                          return false;
                        } }
                      >
                        { profilePicFileList.length === 1 ? null : 'Upload' }
                      </UploadFile>
                    </Form.Item>
                  </Col> */}
                </Row>
              </div>

              {
                personalInformationEditMode &&
                <div className="employeeInfo-update">
                  <Button className="employeeInfo-update-cancel" onClick={ handleSaveClick }>
                    <span style={ { color: "#EA4335" } }>Cancel</span>
                  </Button>
                  <SaveButton className="employeeInfo-update-save" type="primary" htmlType="submit" loading={ loader } >Update</SaveButton>
                </div>
              }
            </Form>
          </Skeleton>
        </div>


        <div style={ { background: "white", border: '1px solid #C9D6DF', marginTop: 20, borderRadius: 10 } }>
          <CardHeader
            title="CNIC"
            canEdit={ !CNICEditMode && checkPermissions('profile_employeeEmployment') }
            onEdit={ handleEditClickCNIC }
          />
          { CNICEditMode ? (
            <Form
              { ...formLayout }
              form={ form }
              name={ formName }
              onFinish={ onSubmitFirstStep }
              className="custom-form"
              scrollToFirstError
            >
              <div style={ { marginLeft: 12, marginTop: 20 } }>
                <Row gutter={ [30, 0] }>
                  <Col span={ 12 }>
                    <Form.Item name="cnic_no" rules={ selectedNationality === 166 ? rules.cnic_no : [] } label={ fieldLabel("cnic_no", trans(`${langKey}.cnic`)) } className="da-mb-16 my-custom-form-item"
                      { ...getErrorProps(errors['cnic_no']) } size="small"
                    >
                      <InputText
                        placeholder="Enter Your CNIC Number" onChange={ onChangeCnic } />
                    </Form.Item>

                    <Form.Item name="cnic_expiry_date" rules={ rules.cnic_expiry_date } label={ fieldLabel("cnic_expiry_date", trans(`${langKey}.cnicEpiry`)) } className="da-mb-16"
                      { ...getErrorProps(errors['cnic_expiry_date']) } size="small"
                    >
                      <InputDate
                        format="DD-MMM-YYYY" />
                    </Form.Item>
                  </Col>

                  <Col span={ 12 }>
                    <Form.Item label={ fieldLabel("cnic_attachment", trans(`${langKey}.cnicAttach`)) } name="cnic_attachment" >
                      <UploadFile
                        fileList={ cnicFileList }
                        setFileList={ setcnicFileList } />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div className="employeeInfo-update">
                <Button className="employeeInfo-update-cancel" onClick={ () => setCNICEditMode(false) }>
                  <span style={ { color: "#EA4335" } }>Cancel</span>
                </Button>
                <SaveButton className="employeeInfo-update-save" type="primary" htmlType="submit" loading={ loader }>Update</SaveButton>
              </div>
            </Form>
          ) : (
            <div>
              <Form
                { ...formItemLayout }
                layout="vertical"
                form={ form }
                name={ formName }
                onFinish={ onSubmitFirstStep }
                className="custom-form"
                disabled={ true }
                scrollToFirstError
              >
                <div style={ { marginLeft: 30, marginTop: 20 } }>
                  <Row gutter={ [30, 0] }>
                    <Col span={ 12 }>
                      <Form.Item name="cnic_no" rules={ selectedNationality === 166 ? rules.cnic_no : [] } label={ fieldLabel("cnic_no", trans(`${langKey}.cnic`)) } className="da-mb-16"
                        { ...getErrorProps(errors['cnic_no']) } size="small"
                      >
                        <InputText
                          bordered={ false }
                          placeholder="Enter Your CNIC Number" onChange={ onChangeCnic } />
                      </Form.Item>

                      <Form.Item name="cnic_expiry_date" rules={ rules.cnic_expiry_date } label={ fieldLabel("cnic_expiry_date", trans(`${langKey}.cnicEpiry`)) } className="da-mb-16"
                        { ...getErrorProps(errors['cnic_expiry_date']) } size="small"
                      >
                        <InputDate
                          bordered={ false }
                          format="DD-MMM-YYYY" />
                      </Form.Item>
                    </Col>

                    <Col span={ 12 }>
                      <Form.Item label={ fieldLabel("cnic_attachment", trans(`${langKey}.cnicAttach`)) } name="cnic_attachment" >
                        <UploadFile

                          fileList={ cnicFileList }
                          setFileList={ setcnicFileList } />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Form>
            </div>
          ) }
        </div>


        <div style={ { background: "white", border: '1px solid #C9D6DF', marginTop: 20, borderRadius: 10 } }>
          <CardHeader
            title="Driving"
            canEdit={ !drivingEditMode && checkPermissions('profile_employeeEmployment') }
            onEdit={ handleEditClickDriving }
          />
          { drivingEditMode ? (
            <Form
              { ...formLayout }
              form={ form }
              name={ formName }
              onFinish={ onSubmitFirstStep }
              className="custom-form"
              scrollToFirstError
            >
              <div style={ { marginLeft: 12, marginTop: 20 } }>
                <Row gutter={ [30, 0] }>
                  <Col span={ 12 }>
                    <Form.Item name="driving_license_no" rules={ rules.driving_license_no } label={ fieldLabel("driving_license_no", trans(`${langKey}.driving`)) } className="da-mb-16" size="small">
                      <InputText
                        placeholder="Enter here"
                      />
                    </Form.Item>

                    <Form.Item name="driving_license_expiry_date" rules={ rules.driving_license_expiry_date } label={ fieldLabel("driving_license_expiry_date", trans(`${langKey}.drivingEpiry`)) } className="da-mb-16" size="small">
                      <InputDate
                        format="DD-MMM-YYYY"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={ 12 }>
                    <Form.Item label={ fieldLabel("driving_license_attachment", trans(`${langKey}.drivingAttach`)) } name="driving_license_attachment" >
                      <UploadFile
                        fileList={ drivingLicenseFileList }
                        setFileList={ setdrivingLicenseFileList } />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div className="employeeInfo-update">
                <Button className="employeeInfo-update-cancel" onClick={ () => setDrivingEditMode(false) }>
                  <span style={ { color: "#EA4335" } }>Cancel</span>
                </Button>
                <SaveButton className="employeeInfo-update-save" type="primary" htmlType="submit" loading={ loader }>Update</SaveButton>
              </div>
            </Form>
          ) : (
            <div>
              <Form
                { ...formItemLayout }
                layout="vertical"
                form={ form }
                name={ formName }
                onFinish={ onSubmitFirstStep }
                className="custom-form"
                disabled={ true }
                scrollToFirstError
              >
                <div style={ { marginLeft: 30, marginTop: 20 } }>
                  <Row gutter={ [30, 0] }>
                    <Col span={ 12 }>
                      <Form.Item name="driving_license_no" rules={ rules.driving_license_no } label={ fieldLabel("driving_license_no", trans(`${langKey}.driving`)) } className="da-mb-16" size="small">
                        <InputText
                          bordered={ false }
                          placeholder="Enter here"
                        />
                      </Form.Item>

                      <Form.Item name="driving_license_expiry_date" rules={ rules.driving_license_expiry_date } label={ fieldLabel("driving_license_expiry_date", trans(`${langKey}.drivingEpiry`)) } className="da-mb-16" size="small">
                        <InputDate
                          style={ { height: 41, width: "100%" } }
                          bordered={ false }
                          format="DD-MMM-YYYY"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={ 12 }>
                      <Form.Item label={ fieldLabel("driving_license_attachment", trans(`${langKey}.drivingAttach`)) } name="driving_license_attachment" >
                        <UploadFile

                          fileList={ drivingLicenseFileList }
                          setFileList={ setdrivingLicenseFileList } />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Form>
            </div>
          ) }
        </div>


        <div style={ { background: "white", border: '1px solid #C9D6DF', marginTop: 20, borderRadius: 10 } }>
          <CardHeader
            title="Passport"
            canEdit={ !passportEditMode && checkPermissions('profile_employeeEmployment') }
            onEdit={ handleEditClickPassport }
          />
          { passportEditMode ? (
            <Form
              { ...formLayout }
              form={ form }
              name={ formName }
              onFinish={ onSubmitFirstStep }
              className="custom-form"
              scrollToFirstError
            >
              <div style={ { marginLeft: 12, marginTop: 20 } }>
                <Row gutter={ [30, 0] }>
                  <Col span={ 12 }>
                    <Form.Item name="passport_no" rules={ selectedNationality !== 166 ? rules.passport_no : [] } label={ fieldLabel("passport_no", trans(`${langKey}.passport`)) } className="da-mb-16"
                      { ...getErrorProps(errors['passport_no']) } size="small"
                    >
                      <InputText placeholder="XXXXXXXXXX" />
                    </Form.Item>

                    <Form.Item name="passport_expiry_date" rules={ rules.passport_expiry_date } label={ fieldLabel("passport_expiry_date", trans(`${langKey}.passportEpiry`)) } className="da-mb-16"
                      { ...getErrorProps(errors['passport_expiry_date']) } size="small"
                    >
                      <InputDate format="DD-MMM-YYYY" />
                    </Form.Item>
                  </Col>

                  <Col span={ 12 }>
                    <Form.Item label={ fieldLabel("passport_attachment", trans(`${langKey}.passportAttach`)) } name="passport_attachment" >
                      <UploadFile
                        fileList={ passportFileList }
                        setFileList={ setpassportFileList } />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div className="employeeInfo-update">
                <Button className="employeeInfo-update-cancel" onClick={ () => setPassportEditMode(false) }>
                  <span style={ { color: "#EA4335" } }>Cancel</span>
                </Button>
                <SaveButton className="employeeInfo-update-save" type="primary" htmlType="submit" loading={ loader }>Update</SaveButton>
              </div>
            </Form>
          ) : (
            <div>
              <Form
                { ...formItemLayout }
                layout="vertical"
                form={ form }
                name={ formName }
                onFinish={ onSubmitFirstStep }
                className="custom-form"
                disabled={ true }
                scrollToFirstError
              >
                <div style={ { marginLeft: 30, marginTop: 20 } }>
                  <Row gutter={ [30, 0] }>
                    <Col span={ 12 }>
                      <Form.Item name="passport_no" rules={ selectedNationality !== 166 ? rules.passport_no : [] } label={ fieldLabel("passport_no", trans(`${langKey}.passport`)) } className="da-mb-16"
                        { ...getErrorProps(errors['passport_no']) } size="small"
                      >
                        <InputText bordered={ false } placeholder="XXXXXXXXXX" />
                      </Form.Item>

                      <Form.Item name="passport_expiry_date" rules={ rules.passport_expiry_date } label={ fieldLabel("passport_expiry_date", trans(`${langKey}.passportEpiry`)) } className="da-mb-16"
                        { ...getErrorProps(errors['passport_expiry_date']) } size="small"
                      >
                        <InputDate bordered={ false } format="DD-MMM-YYYY" />
                      </Form.Item>

                    </Col>

                    <Col span={ 12 }>
                      <Form.Item label={ fieldLabel("passport_attachment", trans(`${langKey}.passportAttach`)) } name="passport_attachment" >
                        <UploadFile
                          fileList={ passportFileList }
                          setFileList={ setpassportFileList } />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </Form>
            </div>
          ) }
        </div>

        <Modal
          className="employment-history-modal"
          title={
            <span className="employment-history-modal__title">
              Employment History
            </span>
          }
          open={ employmentHistoryVisible }
          onCancel={ () => setEmploymentHistoryVisible(false) }
          closeIcon={ <span className="employment-history-modal__close"><CloseOutlined /></span> }
          footer={ null }
          width={ 900 }
        >
          <Skeleton loading={ employmentHistoryLoader } active>
            { employmentHistory.length === 0 ? (
              <div className="employment-history-empty">No employment history found.</div>
            ) : (
              <div className="employment-history-list">
                { employmentHistory.map((history, index) => (
                  <div className="employment-history-card" key={ history.id || index }>
                    <div className="employment-history-card__header">
                      <div className="employment-history-card__heading">
                        <strong>{ getHistoryTitle(history) }</strong>
                        { history.is_active && <span className="employment-history-current">Current</span> }
                      </div>
                      <span className="employment-history-card__count">
                        { getHistoryCount(history, index) }
                      </span>
                    </div>
                    <div className="employment-history-card__divider" />
                    <div className="employment-history-grid">
                      { historyField('Joining Date', formatHistoryDate(history.joining_date)) }
                      { historyField('Leaving Date', formatHistoryDate(history.end_of_employment?.last_working_date || history.end_of_employment?.resignation_date), !history.end_of_employment ? 'employment-history-field--muted' : '') }
                      { historyField('Department', history.department?.name) }
                      { historyField('Designation', history.designation?.name) }
                      { historyField('Branch', history.branch?.name) }
                      { historyField('Location', history.location?.name) }
                      { historyField('Employee Type', history.employee_type?.name) }
                      { historyField('Contract Type', history.contracttype?.name) }
                      <div className="employment-history-field">
                        <span className="employment-history-field__label">Status</span>
                        <span className={ `employment-history-status ${history.is_active ? 'employment-history-status--active' : 'employment-history-status--inactive'}` }>
                          <span className="employment-history-status__dot" />
                          { history.is_active ? 'Active' : 'Inactive' }
                        </span>
                      </div>
                      { historyField('Reason', history.end_of_employment?.reason?.name) }
                    </div>
                  </div>
                )) }
              </div>
            ) }
          </Skeleton>
        </Modal>
      </>
    )
  }

  return (
    <>
      { firstStep() }
    </>

  )

}

export default UpdateEmployeeInfo

const rules = {
  salutation_id: [
    { required: true, message: trans(`${langKey}.salutation.required`), },
  ],
  first_name: [
    { required: true, message: trans(`${langKey}.firstName.required`), },
  ],
  last_name: [
    { required: true, message: trans(`${langKey}.lastName.required`), },
  ],
  father_or_husband_name: [
    { required: true, message: trans(`${langKey}.fatherName.required`), },
  ],
  gender_id: [
    { required: true, message: trans(`${langKey}.gender.required`), },
  ],
  d_o_b: [
    { required: true, message: trans(`${langKey}.dob.required`), },
  ],
  marital_status_id: [
    { required: false, message: trans(`${langKey}.dob.required`), },
  ],
  nationality_id: [
    { required: true, message: trans(`${langKey}.nationality.required`), },
  ],
  mobile_no: [
    { required: true, message: trans(`${langKey}.mobileNo.required`), },
  ],
  cnic_no: [
    { required: true, message: trans(`${langKey}.cnicNo.required`), }, {
      min: 13
    },
  ],
  passport_no: [
    { required: true, message: trans(`${langKey}.passportNo.required`), },
  ],




};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 23, },
  labelAlign: "left"
}
